import type { SupportedLocale } from "../../lib/localeRoutes";
import { findAllergen } from "./catalog";

export interface BrowserTranslationSession {
  translate(text: string): Promise<string>;
  destroy(): void;
}
export interface BrowserTranslator {
  create(options: { sourceLanguage: string; targetLanguage: string }): Promise<BrowserTranslationSession>;
}

export function getBrowserTranslator(): BrowserTranslator | undefined {
  if (typeof window === "undefined") return undefined;
  return (window as Window & { Translator?: BrowserTranslator }).Translator;
}

export async function translateAllergen(
  text: string,
  source: SupportedLocale,
  target: SupportedLocale,
  provider: BrowserTranslator | undefined,
): Promise<string> {
  if (source === target) return text.trim();
  const known = findAllergen(text, source);
  if (known) return known.names[target];
  if (!provider) throw new Error("translation_unavailable");
  // Start creation in the submit/swap gesture, before awaiting anything else.
  // Chrome may download the requested language pack on first use.
  const session = await provider.create({ sourceLanguage: source, targetLanguage: target });
  try {
    const result = (await session.translate(text.trim())).trim();
    if (!result || result.length > 160 || /[<>]/.test(result) || Array.from(result).some(character => character.charCodeAt(0) < 32)) {
      throw new Error("translation_failed");
    }
    return result;
  } finally {
    session.destroy();
  }
}
